export const comparableDto = {
  "proximityToSubjectMiles": null,
  "influenceDirection": 0,
  "netAdjustmentsPercentage": 0,
  "netAdjustmentsAmount": 0,
  "grossAdjustmentsPercentage": 0,
  "grossAdjustmentsAmount": 0,
  "muellerPropertyId": null,
  "comparableType": null,
  "addressLine1": null,
  "addressLine2": null,
  "addressCity": null,
  "addressState": null,
  "addressPostalCode": null,
  "geocodeLatitude": 0,
  "geocodeLongitude": 0,
  "salePrice": 0,
  "finalListPrice": null,
  "salePricePerGrossLivingArea": 0,
  "dataSources": null,
  "verificationSources": null,
  "comparisonToSubject": null,
  "comments": null,
  "daysOnMarket": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "daysOnMarket": 0,
    "daysOnMarketAdjustmentAmount": 0,
    "adjustmentFactorApplied": false
  },
  "saleFinancingConcessions": {
    "summarySale": null,
    "summarySaleAdjustmentAmount": 0,
    "summaryFinancing": null,
    "summaryFinancingAdjustmentAmount": 0,
    "saleType": null,
    "financingType": null,
    "concessionAmount": 0,
    "concessionOtherAmount": 0,
    "concessionAdjustmentAmount": 0,
    "concessionOtherAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "financingTypeAdjustmentAmount": 0
  },
  "dateOfSaleTime": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "statusType": null,
    "saleDate": null,
    "contractDate": null,
    "saleDateAdjustmentAmount": 0,
    "contractDateAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "location": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "locationRating": null,
    "locationType": null,
    "locationType2": null,
    "locationType1Other": null,
    "locationType2Other": null,
    "locationRatingAdjustmentAmount": 0,
    "locationTypeAdjustmentAmount": 0,
    "locationType2AdjustmentAmount": 0,
    "locationType1OtherAdjustmentAmount": 0,
    "locationType2OtherAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "leasholdFeeSimple": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "leaseholdFeeSimpleType": null,
    "leaseholdFeeSimpleTypeAdjustmentAmount": 0
  },
  "site": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "landAreaSquareFeet": 0,
    "landAreaAcres": 0,
    "landAreaSquareFeetAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "view": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "viewRating": null,
    "viewType": null,
    "viewType2": null,
    "viewRatingAdjustmentAmount": 0,
    "viewTypeAdjustmentAmount": 0,
    "adjustmentFactorApplied": false
  },
  "design": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "attachedDetached": null,
    "stories": 0,
    "designStyle": null,
    "adjustmentFactorApplied": false
  },
  "quality": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "qualityRating": null,
    "qualityRatingAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "actualAge": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "ageYears": 0,
    "ageEstimated": false,
    "ageYearsAdjustmentAmount": 0,
    "ageEstimatedAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "condition": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "conditionRating": null,
    "conditionAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "aboveGradeRooms": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "secondSummaryAdjustmentAmount": 0,
    "totalRoomCount": 0,
    "bedroomCount": 0,
    "fullBathroomCount": 0,
    "halfBathroomCount": 0,
    "totalRoomCountAdjustmentAmount": 0,
    "bedroomCountAdjustmentAmount": 0,
    "fullBathroomCountAdjustmentAmount": 0,
    "halfBathroomCountAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "grossLivingArea": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "grossLivingArea": 0,
    "grossLivingAreaAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "belowGrade": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "totalSquareFeet": 0,
    "finishedSquareFeet": 0,
    "basementExitType": null,
    "totalSquareFeetAdjustmentAmount": 0,
    "finishedSquareFeetAdjustmentAmount": 0,
    "basementExitTypeAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "summaryAdjustmentDesc": null
  },
  "belowGradeRooms": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "recRoomCount": 0,
    "bedroomCount": 0,
    "fullBathroomCount": 0,
    "halfBathroomCount": 0,
    "otherRoomCount": 0,
    "recRoomCountAdjustmentAmount": 0,
    "bedroomCountAdjustmentAmount": 0,
    "fullBathroomCountAdjustmentAmount": 0,
    "halfBathroomCountAdjustmentAmount": 0,
    "otherRoomCountAdjustmentAmount": 0,
    "adjustmentFactorApplied": false
  },
  "functionalUtility": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "functionalUtility": null,
    "functionalUtilityAdjustmentAmount": 0
  },
  "heatingCooling": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "heatingType": null,
    "coolingType": null,
    "heatingTypeAdjustmentAmount": 0,
    "coolingTypeAdjustmentAmount": 0,
    "adjustmentFactorApplied": false
  },
  "energyEfficientItems": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "energyEfficientItems": null,
    "energyEfficientItemsAdjustmentAmount": 0
  },
  "garageCarport": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "drivewayType": null,
    "drivewayCarCapacity": 0,
    "carStorageType1": null,
    "carStorageAttachmentType1": null,
    "carStorageCarCapacity1": 0,
    "carStorageType2": null,
    "carStorageAttachmentType2": null,
    "carStorageCarCapacity2": 0,
    "drivewayTypeAdjustmentAmount": 0,
    "drivewayCarCapacityAdjustmentAmount": 0,
    "carStorageTypeAdjustmentAmount1": 0,
    "carStorageAttachmentTypeAdjustmentAmount1": 0,
    "carStorageCarCapacityAdjustmentAmount1": 0,
    "carStorageTypeAdjustmentAmount2": 0,
    "carStorageAttachmentTypeAdjustmentAmount2": 0,
    "carStorageCarCapacityAdjustmentAmount2": 0,
    "summaryAdjustmentDesc": null
  },
  "imageURLs": null,
  "porchPatioDeck": {
    "summary": null,
    "summaryAdjustmentAmount": null,
    "porchType": null,
    "patioDeckType": null,
    "porchPatioDeckTypeAdjustmentAmount": null
  },
  "primaryPhotoId": null,
  "fireplace": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "fireplaceCount": null,
    "fireplaceCountAdjustmentAmount": null,
    "adjustmentFactorApplied": false
  },
  "other": {
    "otherDesc": null,
    "other2Desc": null,
    "other3Desc": null,
    "otherType": null,
    "other2Type": null,
    "other3Type": null,
    "otherTypeAdjustmentAmount": 0,
    "other2TypeAdjustmentAmount": 0,
    "other3TypeAdjustmentAmount": 0,
    "summaryAdjustmentDesc": null
  },
  "cdom": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "cdom": 0
  },
  "propertyType": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "propertyType": null,
    "propertyTypeAdjustmentAmount": 0
  },
  "numOfUnits": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "numOfUnits": 0,
    "numOfUnitsAdjustmentAmount": 0
  },
  "yearBuilt": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "yearBuilt": null,
    "yearBuiltAdjustmentAmount": 0
  },
  "numOfFloors": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "numOfFloors": 0,
    "numOfFloorsAdjustmentAmount": 0
  },
  "floorLocation": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "floorLocation": null,
    "floorLocationAdjustmentAmount": 0
  },
  "monthlyRentalRate": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "monthlyRentalRate": 0,
    "monthlyRentalRateAdjustmentAmount": 0
  },
  "belowGradeRoomCount": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "adjustmentFactorApplied": false,
    "belowGradeRoomCount": 0,
    "belowGradeRoomCountAdjustmentAmount": 0
  },
  "pool": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "pool": null,
    "poolAdjustmentAmount": 0
  },
  "unit1": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "secondSummaryAdjustmentAmount": 0,
    "totalRoomCount": 0,
    "bedroomCount": 0,
    "fullBathroomCount": 0,
    "halfBathroomCount": 0,
    "totalRoomCountAdjustmentAmount": 0,
    "bedroomCountAdjustmentAmount": 0,
    "fullBathroomCountAdjustmentAmount": 0,
    "halfBathroomCountAdjustmentAmount": 0,
    "adjustmentFactorApplied": false
  },
  "unit2": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "secondSummaryAdjustmentAmount": 0,
    "totalRoomCount": 0,
    "bedroomCount": 0,
    "fullBathroomCount": 0,
    "halfBathroomCount": 0,
    "totalRoomCountAdjustmentAmount": 0,
    "bedroomCountAdjustmentAmount": 0,
    "fullBathroomCountAdjustmentAmount": 0,
    "halfBathroomCountAdjustmentAmount": 0,
    "adjustmentFactorApplied": false
  },
  "unit3": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "secondSummaryAdjustmentAmount": 0,
    "totalRoomCount": 0,
    "bedroomCount": 0,
    "fullBathroomCount": 0,
    "halfBathroomCount": 0,
    "totalRoomCountAdjustmentAmount": 0,
    "bedroomCountAdjustmentAmount": 0,
    "fullBathroomCountAdjustmentAmount": 0,
    "halfBathroomCountAdjustmentAmount": 0,
    "adjustmentFactorApplied": false
  },
  "unit4": {
    "summary": null,
    "summaryAdjustmentAmount": 0,
    "secondSummaryAdjustmentAmount": 0,
    "totalRoomCount": 0,
    "bedroomCount": 0,
    "fullBathroomCount": 0,
    "halfBathroomCount": 0,
    "totalRoomCountAdjustmentAmount": 0,
    "bedroomCountAdjustmentAmount": 0,
    "fullBathroomCountAdjustmentAmount": 0,
    "halfBathroomCountAdjustmentAmount": 0,
    "adjustmentFactorApplied": false
  },
};
